// src/components/LimitReachedModal.js

import React from 'react';

export default function LimitReachedModal({
  show,
  onClose,
  resetTime,
  limit,
  plan, // <-- New prop
}) {
  if (!show) return null;

  // Default content for the free plan
  let message = `You've hit the ${limit}-message daily limit for the free plan.`;
  let ctaText = 'Upgrade to Professional for more access.';
  let showUpgradeButton = true;

  // Content for the professional plan
  if (plan === 'professional') {
    message = `You've hit your daily limit of ${limit} messages for the Professional plan.`;
    ctaText = 'Upgrade to Elite for our highest limits.';
    showUpgradeButton = true;
  }

  // Content for the elite plan (no upgrade option)
  if (plan === 'elite') {
    message = `You have reached your daily limit of ${limit} messages.`;
    ctaText = ''; // No CTA text needed
    showUpgradeButton = false;
  }

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white text-black rounded-lg shadow-lg p-6 max-w-md w-full text-center">
        <h2 className="text-lg font-semibold mb-3">⚠️ Message Limit Reached</h2>
        
        <p className="mb-4">
          {message}
          <br />
          {ctaText} Please check back after <strong>{resetTime}</strong> UTC.
        </p>

        {showUpgradeButton && (
          <a
            href="/upgrade"
            className="inline-block px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
          >
            Upgrade Now
          </a>
        )}

        <div className="mt-3">
          <button onClick={onClose} className="text-sm text-gray-500 hover:underline">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}